export default __webpack_public_path__ + "static/media/lampBottom_2056.e762b991.gif";